import CommandActionInput_vue_vue_type_script_setup_true_lang_default from "./CommandActionInput.vue.script.js";
//#region src/v2/features/command-palette/components/CommandActionInput.vue
var CommandActionInput_default = CommandActionInput_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { CommandActionInput_default as default };

//# sourceMappingURL=CommandActionInput.vue.js.map